import React, {Component} from 'react';
import OutputValue, {LocalizedOutputValue} from '../components/output/OutputValue';
import Iterate from '../components/container/Iterate';
import {OutputAttachmentRow, OutputAttachmentRowDisabled} from '../components/output/OutputAttachments';
import {OutputBoxBoolean, OutputBoxContent,} from '../components/output/OutputBox';
import {Horizontal, Vertical} from '../components/container/LayoutRow';
import {list} from '../cruds/restApi';
import {classNames} from '../functions/classNames';
import ButtonLink from '../components/output/ButtonLink';
import {OutputLink} from '../components/output/OutputLink';
import PropTypes from 'prop-types';
import getLabel from '../translations/messages';
import './SafetyDataSheetsArchive.css';
import {ShowBasedOnCondition} from "../components/container/ShowBasedOnCondition";
import {
    FULL_SDS_EVALUATION_ENABLED,
    SDS_DELETION_ENABLED,
    ShowBasedOnConfig
} from "../components/container/ShowBasedOnConfig";
import {ConfirmModal} from "../components/container/Modal";
import {Delete} from "react-feather";
import InputText from "../components/input/InputText";
import {fetchDelete} from "../cruds/remote";

class SafetyDataSheetsArchive extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {selected: '', deleteConfirm: false};
    }

    componentDidMount = () => {
        this.fetchResults();
    };

    fetchResults = () => {
        const url = `substances/${this.props.substanceId}/safetyDataSheets`;
        list(url, {})
            .then(data => this.setState({
                data: data, selected: data ? data[0] : '',
            }));
    };

    selectRow = (id) => {
        const {data} = this.state;

        this.setState({selected: data.find(d => d.id === id)});
    };

    renderListRow = (id, creationTimestamp, version) => {
        const isSelected = (this.state.selected.id === id);

        return <div className={classNames('ListRow', isSelected ? 'selected' : '')}
                    key={id}
                    onClick={() => this.selectRow(id)}>
            <div>
                <Horizontal>
                    <Horizontal>
                        <span>{creationTimestamp}</span>
                        <span style={{marginLeft: 15}}>{'(' + version + ')'}</span>
                    </Horizontal>
                    <ShowBasedOnConfig configKey={SDS_DELETION_ENABLED}>
                    <span className="CrudButton">
                        <span className="tooltip">{getLabel(this.context.locale, 'general.delete')}</span>
                        <a name="delete" onClick={() => this.setState({deleteConfirm: true, deleteId: id})}><Delete
                            size={18}/></a>
                    </span>
                    </ShowBasedOnConfig>
                </Horizontal>
            </div>
            <ConfirmModal
                title="general.confirmDeletion.title"
                isOpen={this.state.deleteConfirm}
                submitAction={() => this.handleDelete(this.state.deleteId)}
                handleCloseModal={() => this.setState({deleteConfirm: false})}
                disabled={!this.state.reason}>
                <div className="signature-modal">
                    <InputText name="reason" label="substances.sdsDeletionReason" required={true}
                               handleChange={(e) => this.setState({reason: e.target.value})}></InputText>
                </div>
            </ConfirmModal>

        </div>
            ;
    };

    handleDelete = (id) => {
        fetchDelete(`substances/${this.props.substanceId}/safetyDataSheets/${id}?reason=${this.state.reason}`)
            .then(r => {
                this.setState({deleteConfirm: false});
                this.fetchResults();
            });
    }

    renderSelected = () => {
        const {selected} = this.state;
        return (<Vertical resource={selected}>

            <Vertical>
                <Horizontal style={{backgroundColor: 'rgb(248, 252, 253)'}}>
                    <ShowBasedOnCondition evaluateOnField="downloadable" condition={v => v === true}>
                        <OutputBoxContent label="substances.sds" style={{flex: 1}}>
                            <OutputLink name="sds"/>
                        </OutputBoxContent>
                    </ShowBasedOnCondition>
                    <ShowBasedOnCondition evaluateOnField="downloadable" condition={v => v === false}>
                        <OutputBoxContent label="substances.sds" style={{flex: 1}}>
                            <OutputValue name="sds" style={{color: '#c7c7c7'}}/>
                        </OutputBoxContent>
                    </ShowBasedOnCondition>
                    <ShowBasedOnCondition evaluateOnField="downloadable" condition={v => v === true}>
                        <OutputBoxContent label="substances.attachments" style={{flex: 2}}>
                            <Iterate on="attachments">
                                <OutputAttachmentRow/>
                            </Iterate>
                        </OutputBoxContent>
                    </ShowBasedOnCondition>
                    <ShowBasedOnCondition evaluateOnField="downloadable" condition={v => v === false}>
                        <OutputBoxContent label="substances.attachments" style={{flex: 2}}>
                            <Iterate on="attachments">
                                <OutputAttachmentRowDisabled/>
                            </Iterate>
                        </OutputBoxContent>
                    </ShowBasedOnCondition>
                </Horizontal>
            </Vertical>

            <Vertical rendered="lastSafetyDataSheetEvaluation">
                <Horizontal style={{backgroundColor: 'rgb(248, 252, 253)'}}>
                    <OutputBoxContent label="substances.sdsEvaluationConsiderationCLPShort" style={{flex: 1}}>
                        <LocalizedOutputValue name="lastSafetyDataSheetEvaluation.clp"
                                              prefix="substances.sdsEvaluationConsiderationCLPValues"/>
                    </OutputBoxContent>
                    <OutputBoxBoolean name="lastSafetyDataSheetEvaluation.italianSds"
                                      label="substances.sdsEvaluationItalianSdsShort" style={{flex: 1}}/>
                    <OutputBoxBoolean name="lastSafetyDataSheetEvaluation.pageNumeration"
                                      label="substances.sdsEvaluationPageNumerationShort" style={{flex: 1}}/>
                    <OutputBoxBoolean name="lastSafetyDataSheetEvaluation.sectionsCompleted"
                                      label="substances.sdsEvaluationSectionsCompletedShort" style={{flex: 1}}/>
                </Horizontal>
            </Vertical>
            <ShowBasedOnConfig configKey={FULL_SDS_EVALUATION_ENABLED}>
                <Vertical rendered="lastSafetyDataSheetEvaluation">
                    <Horizontal style={{backgroundColor: 'rgb(248, 252, 253)'}}>
                        <OutputBoxBoolean name="lastSafetyDataSheetEvaluation.sectionsWithoutText"
                                          label="substances.sdsEvaluationSectionsWithoutTextShort" style={{flex: 1}}/>
                        <OutputBoxBoolean name="lastSafetyDataSheetEvaluation.section1"
                                          label="substances.sdsEvaluationSection1Short" style={{flex: 1}}/>
                        <OutputBoxBoolean name="lastSafetyDataSheetEvaluation.section2"
                                          label="substances.sdsEvaluationSection2Short" style={{flex: 1}}/>
                    </Horizontal>
                </Vertical>
            </ShowBasedOnConfig>
            <Vertical rendered="lastSafetyDataSheetEvaluation">
                <Horizontal style={{backgroundColor: 'rgb(248, 252, 253)'}}>
                    <OutputBoxBoolean name="lastSafetyDataSheetEvaluation.compliantSds"
                                      label="substances.sdsEvaluationCompliantSdsShort" style={{flex: 1}}/>
                    <OutputBoxBoolean name="lastSafetyDataSheetEvaluation.usableSds"
                                      label="substances.sdsEvaluationUsableSdsShort" style={{flex: 1}}/>
                    <OutputBoxContent label="substances.sdsEvaluationNoteShort" style={{flex: 3}}>
                        <OutputValue name="lastSafetyDataSheetEvaluation.note"/>
                    </OutputBoxContent>
                </Horizontal>
            </Vertical>

        </Vertical>);
    };

    render() {
        const {data, selected} = this.state;

        return (<div className="SafetyDataSheetArchive">
            <div className="header">
                <h2>{[getLabel(this.context.locale, 'evaluations.archive'), (selected ? selected.code : '')].join(' ')}</h2>
            </div>
            <div className="content">
                <div className="left">
                    {data ? data.map((d, i) => this.renderListRow(d.id, d.creationTimestamp, d.safetyDataSheetVersion)) : ''}
                </div>
                <div className="right">
                    {this.state.selected ? this.renderSelected() : ''}
                </div>
            </div>
            <div className="buttons">
                <ButtonLink to="/substances" label="general.close"/>
            </div>
        </div>);
    }

}

SafetyDataSheetsArchive.contextTypes = {
    locale: PropTypes.string,
};

export default SafetyDataSheetsArchive;



// WEBPACK FOOTER //
// ./src/main/pages/SafetyDataSheetsArchive.js